import * as React from "react";
function TransportTaxiTypeStandard() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 120 120"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#636566",
    fillRule: "nonzero",
    d: "M-52.942,-52.874C-58.275,-52.874 -62.597,-29.172 -62.597,0.068C-62.597,29.307 -58.275,53.01 -52.942,53.01C-47.609,53.01 -43.287,29.308 -43.286,0.068C-43.286,-29.171 -47.608,-52.874 -52.942,-52.874",
    opacity: 0.47,
    transform: "scale(1 -1) rotate(89.926 42.456 17.15)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#939393",
    fillRule: "nonzero",
    d: "M-2.883,-16.659C-1.105,-14.879 1.801,-12.382 1.462,-9.495C1.122,-6.607 -1.217,-0.173 -2.883,0.456L-10.274,-2.262L-2.883,-16.659Z",
    transform: "scale(-1 1) rotate(-21.638 184.737 50.711)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#939393",
    fillRule: "nonzero",
    d: "M-5.556,-21.34C-3.847,-19.493 -0.379,-12.361 -0.829,-9.489C-1.28,-6.616 -3.866,-0.277 -5.556,0.287L-12.341,-2.29L-5.556,-21.34Z",
    transform: "scale(-1 1) rotate(-23.853 153.46 157.118)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M0,10.714C0.313,11.403 2.193,14.473 4.448,15.162C6.704,15.852 10.589,15.476 12.092,14.536C13.596,13.596 14.912,12.844 15.914,10.275C16.917,7.707 18.358,1.88 14.912,-0.877C11.466,-3.634 3.007,-5.138 2.13,-4.135C1.253,-3.133 0,10.714 0,10.714",
    transform: "translate(95.971 65.567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M0,-19.518C-1.126,-18.872 -2.377,-18.33 -3.385,-16.385C-4.393,-14.441 -4.897,-10.876 -4.825,-9.255C-4.753,-7.635 -4.213,-4.43 -2.845,-2.269C-1.476,-0.109 -0.288,0.9 1.44,1.152C3.169,1.404 7.515,1.041 8.271,0.861C9.027,0.681 10.071,0.033 10.576,-0.579C11.08,-1.192 12.196,-2.416 12.808,-5.225C13.42,-8.034 13.568,-12.722 10.615,-17.944C9.08,-20.658 2.449,-20.922 0,-19.518",
    transform: "translate(60.545 81.757)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M-2.181,-2.163C-4.859,-2.185 -7.029,-1.227 -7.029,-0.022C-7.029,1.182 -4.858,2.177 -2.181,2.199C0.497,2.221 2.667,1.262 2.667,0.058C2.667,-1.147 0.497,-2.141 -2.181,-2.163",
    transform: "scale(1 -1) rotate(89.527 66.003 -4.11)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M0,-16.979C-0.98,-16.417 -2.068,-15.945 -2.945,-14.254C-3.822,-12.562 -4.26,-9.46 -4.198,-8.051C-4.135,-6.641 -3.665,-3.853 -2.475,-1.973C-1.284,-0.094 -0.251,0.783 1.253,1.003C2.757,1.222 5.858,1.003 6.516,0.846C7.174,0.69 8.082,0.126 8.521,-0.407C8.96,-0.939 9.931,-2.005 10.463,-4.448C10.996,-6.892 11.34,-10.964 8.772,-15.507C7.436,-17.868 2.13,-18.201 0,-16.979",
    transform: "translate(12.515 77.722)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    fillRule: "nonzero",
    d: "M0,-3.137C0.925,-10.142 4.652,-9.545 7.956,-10.999C10.726,-12.218 13.933,-15.661 18.953,-17.693C29.262,-21.865 49.665,-20.46 62.833,-19.949C72.868,-19.56 86.242,-9.742 89.687,-6.373C89.687,-6.373 89.937,-6.41 92.584,-5.431C94.373,-4.77 97.872,-3.577 98.319,-3.537C98.766,-3.496 99.799,-3.537 101.727,-2.624C108.9,0.772 108.365,8.055 108.146,13.342C108.227,13.789 108.337,14.788 108.309,15.171C108.213,16.46 100.416,18.291 89.563,18.661C87.595,18.728 72.184,18.66 66.669,18.588C65.436,18.572 64.38,17.717 64.091,16.517C63.301,13.23 62.716,8.123 61.954,5.773C59.671,-1.258 50.32,0.621 49.613,8.501C49.158,13.568 49.808,15.646 50.392,17.659C42.069,17.236 23.503,15.841 14.8,14.802C14.162,14.725 12.959,13.992 12.715,12.774C11.65,7.725 13.72,0.636 7.613,-0.197C1.42,0.513 1.363,8.561 2.49,13.305C2.371,13.305 2.084,12.97 1.674,12.722C0.651,12.104 -0.042,10.604 -0.385,9.459C-0.843,7.935 -1.005,6.167 -0.951,4.684C-0.937,4.27 -0.874,3.857 -0.732,3.468C-0.08,1.69 -0.04,-2.235 0,-3.137",
    transform: "translate(6.569 60.597)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M0,5.275C-2.04,4.334 -1.024,3.208 -0.398,2.704C1.411,1.247 5.305,-1.985 11.215,-2.959C15.447,-3.657 20.965,-3.491 24.796,-0.444C28.943,2.855 32.497,7.789 32.987,8.663C31.145,8.932 5.238,7.69 0,5.275",
    transform: "translate(20.666 45.624)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M0,-12.54C0,-12.54 5.17,-9.819 9.255,-5.981C12.113,-3.297 15.109,-0.755 15.49,-0.526C15.872,-0.297 24.409,0.094 28.308,0.015C35.559,-0.132 47.645,-0.648 46.839,-0.591C46.839,-0.591 42.522,-3.779 36.758,-7.287C31.58,-10.439 30.088,-10.954 25.966,-11.794C21.844,-12.634 0,-12.54 0,-12.54",
    transform: "translate(45.495 54.85)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#474646",
    fillRule: "nonzero",
    d: "M0,-7.948C-2.093,-8.374 -8.756,-8.56 -14.808,-8.639C-13.496,-7.7 -12.096,-6.598 -10.803,-5.384C-7.946,-2.7 -4.95,-0.158 -4.569,0.071C-4.187,0.3 4.35,0.691 8.249,0.612C10.747,0.562 13.814,0.467 16.734,0.367C15.091,-0.738 13.056,-2.063 10.792,-3.441C5.615,-6.593 4.122,-7.108 0,-7.948",
    transform: "translate(65.554 54.254)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5AAAD",
    fillRule: "nonzero",
    d: "M0,-7.081C1.097,-3.868 5.133,-0.968 5.656,-0.835C7.175,-0.45 11.695,0.056 14.062,-0.173C14.899,-0.254 17.347,-0.496 17.724,-0.873C15.764,-1.88 9.456,-4.95 3.13,-6.547C0.789,-7.137 0,-7.081 0,-7.081",
    transform: "translate(69.477 64.82)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5AAAD",
    fillRule: "nonzero",
    d: "M0,-5.492C0.596,-4.995 1.362,-4.721 2.124,-3.407C2.874,-2.113 2.876,-0.561 3.348,-0.258C3.821,0.045 5.48,-0.161 5.865,-0.29C6.68,-0.561 6.291,-1.306 6.291,-1.306C6.291,-1.306 5.56,-3.106 4.295,-3.979C3.493,-4.532 0.49,-5.537 0,-5.492",
    transform: "translate(105.246 64.155)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    fillRule: "nonzero",
    d: "M0,-4.674C1.944,-4.581 9.375,-4.482 14.217,-5.098C14.755,-5.167 15.46,-4.955 15.79,-4.524C15.946,-4.32 16.075,-4.064 16.12,-3.751C16.262,-2.751 16.545,-0.813 16.545,-0.813C16.545,-0.813 11.298,0.214 7.539,0.276C3.78,0.339 -1.731,0.493 -4.055,0.156C-3.88,-0.599 -3.607,-2.952 -3.303,-3.554C-2.696,-4.755 -1.377,-4.74 0,-4.674",
    transform: "translate(94.05 73.277)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M-1.75,-1.75C-4.199,-1.75 -6.184,-0.966 -6.184,0C-6.184,0.967 -4.199,1.75 -1.75,1.75C0.699,1.75 2.684,0.967 2.684,0C2.684,-0.966 0.699,-1.75 -1.75,-1.75",
    transform: "matrix(0 -1 -1 0 12.554 67.77)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    fillRule: "nonzero",
    d: "M0,-12.173C-0.448,-11.478 -0.88,-10.964 -2.194,-8.11C-4.377,-3.368 -4.422,-0.497 -4.422,-0.497L-0.752,0C-0.752,0 -0.245,-2.883 0.234,-4.476C0.713,-6.07 2.209,-10.427 3.642,-12.168L0,-12.173Z",
    transform: "translate(34.73 53.947)"
  }));
}
export default TransportTaxiTypeStandard;